import gql from 'graphql-tag';

export const AnswerCampaignQuestion = gql`
  mutation answerCampaignQuestion($answer: CampaignAnswerCreate!) {
    answerCampaignQuestion(answer: $answer) {
      id
    }
  }
`;
